import BackendConfigService from '../configs/backendConfigService'
import AuthService from '../authService'
import USUARIO_LOGADO from '../authService'
import ProvedorAutenticacao from '../provedorAutenticacao'
class BackendService extends BackendConfigService {
    
    constructor(){

        let headers = {}
        
        let isAuth = AuthService.isAuthenticated()
        let userAuth = AuthService.obterUsuarioAutenticado(USUARIO_LOGADO)
        if(isAuth && (userAuth && userAuth.authorization)){
            headers = {
                "Authorization":`Token ${userAuth.authorization}`
            }
        }
        super('', headers)
    }

    try_or_redirect(status_code){
        if (status_code === 403){
            new ProvedorAutenticacao().encerrarSessao()
            window.location.href = '/'
        }
    }
    get_salas(){
        return this.get(`${this.get_base_url_agenda_saude()}/salas/`)
    }

    async get_finalidades(){
        try{
            return await this.get(`${this.get_base_url_agenda_saude()}/finalidades/`)
        }catch(error){
            this.try_or_redirect(error.response.status)
            throw new Error(error)
        }
    }

    get_cursos(){
        let perlet = this.periodoLetivoAtual()
        let usuario = this.usuarioLogado().username
        return this.get(`${this.get_base_url_agenda_saude()}/cursos/?usuario=${usuario}&codperlet=${perlet}`)
    }

    get_disciplinas(){
        let perlet = this.periodoLetivoAtual()
        let usuario = this.usuarioLogado().username
        return this.get(`${this.get_base_url_agenda_saude()}/disciplinas/?usuario=${usuario}&codperlet=${perlet}`)
    }

    get_turmas(){
        let perlet = this.periodoLetivoAtual()
        let usuario = this.usuarioLogado().username
        return this.get(`${this.get_base_url_agenda_saude()}/turmas/?usuario=${usuario}&codperlet=${perlet}`)
    }

    usuarioLogado(){
        return AuthService.obterUsuarioAutenticado(USUARIO_LOGADO)
    }

    periodoLetivoAtual(){
        let data = new Date()
        let ano = data.getFullYear()
        let mes = data.getMonth() + 1
        let semestre = mes <= 6 ? 1 : 2
        return `${ano}.${semestre}` 
    }

    get_settings(){
        return this.get(`${this.get_base_url_agenda_saude()}/settings/`)
    }

    post_agendamento(agenda, headersMultiPart){
        this.headers = {...this.headers, "Content-Type": "multipart/form-data", ...headersMultiPart}
        return this.post(`${this.get_base_url_agenda_saude()}/agendamentos/`, agenda)
    }
    
    get_agendamentos(params=''){
        return this.get(`${this.get_base_url_agenda_saude()}/agendamentos/`+params)
    }
    
    patch_agendamento(pk, data){
        return this.patch(`${this.get_base_url_agenda_saude()}/agendamentos/${pk}/`,data)
    }

    patch_settings(pk, data){
        return this.patch(`${this.get_base_url_agenda_saude()}/settings/${pk}/`,data)
    }
    
    aprova_reserva(pk, data){
        return this.patch(`${this.get_base_url_agenda_saude()}/agendamentos/aprovacao/${pk}/`,data)
    }

    
}

export default BackendService